__turbopack_context__.v({
  "button": "vpn-relay-welcome-module-scss-module__tCGRTW__button",
  "content-body": "vpn-relay-welcome-module-scss-module__tCGRTW__content-body",
  "content-container": "vpn-relay-welcome-module-scss-module__tCGRTW__content-container",
  "content-head": "vpn-relay-welcome-module-scss-module__tCGRTW__content-head",
  "disabled": "vpn-relay-welcome-module-scss-module__tCGRTW__disabled",
  "headline": "vpn-relay-welcome-module-scss-module__tCGRTW__headline",
  "is-destructive": "vpn-relay-welcome-module-scss-module__tCGRTW__is-destructive",
  "is-secondary": "vpn-relay-welcome-module-scss-module__tCGRTW__is-secondary",
  "logo": "vpn-relay-welcome-module-scss-module__tCGRTW__logo",
  "panel": "vpn-relay-welcome-module-scss-module__tCGRTW__panel",
  "panel-art": "vpn-relay-welcome-module-scss-module__tCGRTW__panel-art",
  "subheadline": "vpn-relay-welcome-module-scss-module__tCGRTW__subheadline",
});
